<template>
  <main id="page-forgot-password" class="news-page">
    <header class="masthead">
      <div class="masthead__rule masthead__rule--thick"></div>
      <div class="masthead__rule masthead__rule--thin"></div>
      <div class="masthead__inner">
        <p class="masthead__kicker">Platforma Română de</p>
        <h1 class="masthead__title">Sondaje de Opinie</h1>
        <p class="masthead__tagline">Voce. Date. Adevăr.</p>
      </div>
      <div class="masthead__rule masthead__rule--thick"></div>
    </header>

    <section class="auth-card forgot-password-card">
      <h2 class="forgot-password-card__title">Recuperare parolă</h2>

      <div v-if="successMessage" class="auth-card__message">
        {{ successMessage }}
      </div>

      <div v-else>
        <p class="forgot-password-card__desc">
          Introduceți adresa de email sau username-ul contului dvs.
        </p>

        <form class="auth-form" @submit.prevent="submit">
          <FormField
            v-model="login"
            label="Email sau username"
            placeholder="ionescu sau ion@exemplu.ro"
            :errors="errors.login"
          />

          <div v-if="errorMessage" class="auth-card__error">{{ errorMessage }}</div>

          <button type="submit" class="auth-form__submit" :disabled="isSubmitting">
            {{ isSubmitting ? 'Se procesează...' : 'Trimite link de resetare' }}
          </button>
        </form>
      </div>

      <div class="forgot-password-card__back">
        <button type="button" class="auth-form__forgot-link" @click="$router.push({ name: 'home' })">
          ← Înapoi la autentificare
        </button>
      </div>
    </section>
  </main>
</template>

<script>
import FormField from '../../components/FormField.vue';

export default {
  name: 'ForgotPasswordView',
  components: { FormField },

  data() {
    return {
      login: '',
      isSubmitting: false,
      successMessage: '',
      errorMessage: '',
      errors: {},
    };
  },

  methods: {
    async submit() {
      this.isSubmitting = true;
      this.errorMessage = '';
      this.errors = {};

      try {
        const response = await window.axios.post('/auth/forgot-password', {
          login: this.login,
        });

        const data = response.data;

        if (data.status === 'email_sent') {
          this.successMessage = 'Verificați inbox-ul. Am trimis un link de resetare la adresa de email asociată contului.';
        } else if (data.status === 'chat_created') {
          window.localStorage.setItem('chat_id', String(data.chat_id));
          this.$router.push({ name: 'home' });
        }
      } catch (err) {
        if (err.response?.status === 422) {
          const data = err.response.data;
          if (data.errors) {
            this.errors = data.errors;
          } else {
            this.errorMessage = data.message || 'A apărut o eroare. Încercați din nou.';
          }
        } else {
          this.errorMessage = 'A apărut o eroare. Încercați din nou.';
        }
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
